(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageController', ImageStorageController);

    ImageStorageController.$inject = ['$scope', '$state', 'DataUtils', 'ImageStorage', 'ImageStorageSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DEBUG_INFO_ENABLED'];

    function ImageStorageController ($scope, $state, DataUtils, ImageStorage, ImageStorageSearch, ParseLinks, AlertService, paginationConstants, pagingParams, DEBUG_INFO_ENABLED) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        getBaseUrl();
        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ImageStorageSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ImageStorage.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.imageStorages = data;
                vm.page = pagingParams.page;
                setTimeout(function () {
                    enableClipboard();
                }, 0);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }
        function getBaseUrl() {
            if (DEBUG_INFO_ENABLED) {
                vm.location = location.origin;
            }
            else {
                vm.location = 'https://admin.apextech.uz';
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
